import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClearIcon from "@mui/icons-material/Clear";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Controller } from "react-hook-form";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
		},
	},
};

const ClearButton = (name, resetField) => {
	return (
		<IconButton
			sx={{ p: "5px" }}
			type="button"
			onClick={() => resetField(name)}
		>
			<ClearIcon sx={{ fontSize: 16 }} />
		</IconButton>
	);
};

const ControlledSelect = ({
	control,
	name,
	label,
	defaultValue,
	options,
	margin,
	error,
	allowRefresh = false,
	resetField,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => {
				return (
					<FormControl fullWidth margin={margin}>
						<InputLabel size="small" id={name}>
							{label}
						</InputLabel>
						<Select
							name={name}
							IconComponent={
								allowRefresh && value
									? () => ClearButton(name, resetField)
									: ArrowDropDownIcon
							}
							labelId={name}
							value={value}
							label={label}
							size="small"
							error={error}
							{...rest}
							onChange={(value) => {
								onChange(value);
								rest?.onChange && rest.onChange();
							}}
							MenuProps={MenuProps}
						>
							{options.map((option) => (
								<MenuItem
									key={option.value}
									value={option.value}
									disabled={option.disabled || false}
								>
									{option.label}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				);
			}}
		/>
	);
};

export default ControlledSelect;
